export const courseList = [
    {
        photo: "../assets/HK/courseLogo1.png", title: "幼小銜接補習課程", content: "課程設有看圖認字、筆順結構、聯想造詞、看圖等內容，安排闖關活動、識字遊戲，趣味性的練習，重視視覺感知、語音意識、語素意識、構字能力、書寫技巧的提升。真正將兒童的興趣、探索與創造融為一體，在帶動兒童興趣及思維的基礎上，體驗學習的快樂，並幫助孩子銜接小一課程。"
    },
    {
        photo: "../assets/HK/courseLogo2.png", title: "全面提高班課程", content: "小學全面提高班課程結合香港小學學習字詞表，整合《活學中國語文》《我愛學語文》《現代中國語文》等編撰而成，緊跟學校課程，拓展教材內容。中學同步提高班參考《啟思中國語文》等教材獨立研發提升學生能力課件，通過1對1的私人訂製課程，重視認字組句、閱讀理解、習作表達等方面，最終全面提升學生的語文能力。"
    },
    {
        photo: "../assets/HK/courseLogo3.png", title: "呈分試補習課", content: "課程包括聆聽、說話、閱讀習作三部分，注重中文綜合能力的提高。舉一反三，教授答題技巧，對錯題進行歸納分析，減少錯別字等失誤失分。熟悉不同文體的寫作技巧，掌握成語、修辭手法的運用，積累好句。對詞語、句子、語段進行分析，提升閱讀理解能力，學會審題，了解文章重要主旨。通過聆聽音頻，集中注意力，學會抓住重點。"

    },
    {
        photo: "../assets/HK/courseLogo4.png", title: "閱讀理解與寫作專項提高班", content: "小學閱讀課通過劃分句段、整合框架等方法了解文章內容主旨，提升閱讀敏感度，掌握答題技巧。小學寫作課主要是熟悉日記、記敍文、描寫文，說明文等文體，學習總分總框架組織等方法，整體提升習作能力。中學寫作專項課包括记敍、抒情和議論等更多文體的寫作技巧和知識。通過以讀帶寫，因材施教，課程內容多元化，激發學生寫作興趣，從審題、立意、構思、選材等方面入手，解決學生寫作難點，提升寫作能力。"

    },
    {
        photo: "../assets/HK/courseLogo5.png", title: "文言文專項輔導課", content: "根據中國語文課程指引為設計依據，以香港教育部發佈的中學建議篇章篇目及補充內容為教學重點，文言文專項課程包括文言實詞、虛詞，古今異義，特殊文言句式等多個考點，緊密貼合教材，多元拓展，積累文言文應試能力的同時提升中國文化知識，豐富文學素養，促進學生思辨能力發展。"

    },
    {
        photo: "../assets/HK/courseLogo6.png", title: "白話文專項輔導課", content: "白話文閱讀專項課程，品讀經典名家作品，學習多種閱讀策略，總結題型過程中幫助學生掌握白話文閱讀答題技巧，程難點螺旋上升，易於學生理解學習，滲入DSE題型，預早熟習公開試題。"
    },
];
export const teacherList = [{
    color: "#C4EFDC", picture: "../assets/HK/teacher1.png", name: "王君慧老師", quality: "跨文化交流碩士", introduce: "悉尼大學畢業，持有普通話二甲證書，掌握普通話、粵語、日語、英語四種語言，漢語言文學學士學位，跨文化交流碩士學位，教學理念：致力讓學習中文成為一件快樂的事情。"
},
{
    color: "#F9F3FF", picture: "../assets/HK/teacher2.png", name: "王晶晶老師", quality: "國際漢語注冊老師", introduce: "擁有10年教學工作經驗，擁有國內培訓老師、線上中文教師及線下英文老師等工作經驗。講課生動有趣，能夠根據學生的行為，語言方式，心理特點等進行因材施教，擅於抓住學生注意力，所教授學生范圍3歲至成人，尤其對3至12歲學生的教學更為突出。學生及家長好評率達99%。"
},
{
    color: "#E8EBCD", picture: "../assets/HK/teacher3.png", name: "楊燕玲老師", quality: "對外漢語資深老師", introduce: "擁有4年線上對外漢語教學經驗，普通話二甲證書，漢語言專業學士學位，學生累計達1000多名，學生及家長好評率達99%，線上累計授課時長5000小時，教學理念：一棵樹搖動另一棵樹，一朵雲推動另一朵雲，一個靈魂喚醒另一個靈魂。"
}
];
export const serviceList = [
    {
        title: "學員檔案升級", content: "升級精美學員檔案，全面記錄學員的學習進程和成長片段。檔案包括課程記錄、測試成績、教師評估等。學員的進步看得見，讓學員為自己的成就感到自豪。", picture: "../assets/HK/service1.png"
    },
    {
        title: "開班儀式", content: "學員報名後，設置新學期開班儀式。介紹教師團隊和課程計劃，明確課程服務人員職責，教師與學員共同面對新學期的挑戰。", picture: "../assets/HK/service2.png"
    },
    {
        title: "3V1課程服務", content: "授課老師、輔導老師、教研團隊服務一名學員，確保個性化指導，課程全陪伴。課後增加社群服務，包括增設學習小組、分享升學和育兒資料等，以滿足學員多方面需求。", picture: "../assets/HK/service3.png"
    },
    {
        title: "全方位升級教學輔導", content: "根據學生能力和需求提供不同層次的課程，包括同步輔導、專項提升和拔尖課程。檢查學員課後練習，並對其進行分析和針對性指導，查缺補漏。", picture: "../assets/HK/service4.png"
    },
    {
        title: "增設精英拔尖課程", content: "精英班課程由Sinobus名師輔導團隊結合香港名校課程大綱製成，內容涵蓋語基和文法，課後練習的難度加深，廣度加大，旨在提升學員中文綜合能力上限。", picture: "../assets/HK/service5.png"
    },
    {
        title: "考前衝刺輔導", content: "針對入學、期中、期末等考試時間節點增加考前衝刺輔導，幫助學生複習考試重點內容，提供答題技巧，提煉易錯點，爭取考試優異表現。", picture: "../assets/HK/service6.png"
    },
    {
        title: "趣味教學", content: "為確保低年段課程的學員課程集中性，增加課程趣味性。教師授課風格豐富，可根據學員需求調整，最大程度吸引學員注意力，提升課程有效性。", picture: "../assets/HK/service7.png"
    },
    {
        title: "學員反饋", content: "跟蹤學員學習情況，對整體和局部的表現進行日、周、月反饋，以便家長瞭解學員課程進程與學員吸收程度。教師會根據反饋優化課程內容和授課形式，課程質量有保障。", picture: "../assets/HK/service8.png"
    }]
export const parentChatList = [
    { picture: '../assets/HK/p1.png' },
    { picture: '../assets/HK/p2.png' },
    { picture: '../assets/HK/p3.png' }
];